import axios from "axios";
import serviceConfig from "config/serviceConfig";

const apiClient = axios.create({
	baseURL: serviceConfig.api.baseUrl,
	withCredentials: true, // Ensures cookies are sent with requests
	headers: {
		Accept: serviceConfig.headers.accept,
	},
});

// 2) Add request interceptor
apiClient.interceptors.request.use(
	(config) => {
		const csrfToken = localStorage.getItem("csrf-token");
		if (csrfToken) {
			config.headers["X-CSRF-Token"] = csrfToken;
		}

		// Check if the request data is FormData, and set Content-Type accordingly
		if (config.data instanceof FormData) {
			config.headers["Content-Type"] = "multipart/form-data";
		} else {
			config.headers["Content-Type"] = "application/json";
		}

		return config;
	},
	(error) => Promise.reject(error),
);

export default apiClient;

export const handleAxiosError = (error: unknown) => {
	if (axios.isAxiosError(error)) {
		throw error.response?.data;
	}
	throw new Error("An unexpected error occurred.");
};
